<template>
  <div class="solucao-card w-full md:w-6 lg:w-4 px-3 mb-8">
    <div class="w-full" :class="(itemIndex % 3  == 0 || itemIndex % 3 == 1 ? 'fade-in-left' : 'fade-in-right')">
      <div class="card-container">
        <div v-if="item.novaSolucao" class="etiqueta-destaqueSolucao">
          <div class="etiquetaText" v-html="fc_getText(null, 'novidade')"></div>
        </div>
        <div class="logotipo">
          <div class="logo-wrapper">
            <img @click="fc_goRoute('solucao', { id: item.id })" :src="item.logotipo" class="logo-img cursorPointer" />
            <div class="logo-underline"></div>
          </div>
        </div>
        <div class="text-content">
          <div class="card-title" v-html="item.tituloDestaque"></div>
          <div class="card-description" v-html="item.conteudoDestaque"></div>
        </div>
        <div class="card-footer">
          <div @click="fc_goRoute('solucao', { id: item.id })" class="btn-redireciona" v-html="fc_getText(null,'btn_saberMais')"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  props: {
    item: Object,
    itemIndex: Number,
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {},
  unmounted() {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
  .solucao-card {
    display: flex;
  }
  .card-container {
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
    padding: 30px 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
  }
  .card-container:hover {
    transform: translateY(-4px);
    box-shadow: 0 18px 40px rgba(0, 0, 0, 0.12);
  }
  .logotipo {
    text-align: center;
    margin-bottom: 40px;
  }
  .logo-wrapper {
    height: 130px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    position: relative;
  }
  .logo-img {
    max-height: 80px;
    width: auto;
    object-fit: contain;
    transition: transform 0.3s ease;
  }
  .card-container:hover .logotipo .logo-img {
    transform: scale(1.05);
  }
  .logo-underline {
    width: 25%;
    height: 4px;
    background-color: var(--ibase-color);
    margin: 20px auto 0;
    border-radius: 2px;
  }
  .text-content {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
  }
  .card-title {
    font-size: 20px;
    font-weight: 500;
    color: #202020;
    margin-bottom: 12px;
    min-height: 60px;
    text-align: center;
    font-weight:bold;
  }
  .card-description {
    font-size: 0.95rem;
    color: #888888;
    text-align: justify;
    line-height: 1.6;
    flex-grow: 1;
  }
  .card-footer {
    margin-top: 20px;
    text-align: center;
  }
  .solucao-card .btn-redireciona {
    margin-left: auto;
    margin-right: auto;
  }
  .etiqueta-destaqueSolucao {
    width: 110px;
    height: 110px;
    overflow: hidden;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 10;
  }
  .etiquetaText {
    font-size: 15px;
    font-weight: bold;
    color: #fff;
    text-align: center;
    text-transform: uppercase;
    transform: rotate(45deg);
    position: absolute;
    top: 20px;
    right: -35px;
    width: 160px;
    background-color: var(--ibase-color);
    padding: 5px 0;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  }
</style>
